import {create} from "zustand";

import type {FormDraftRecord} from "@/src/modules/core/lib/form-draft";

type FormDraftResumeStore = {
  pending: FormDraftRecord | null;
  setPending: (draft: FormDraftRecord) => void;
  consumePending: () => FormDraftRecord | null;
  clearPending: () => void;
};

export const useFormDraftResumeStore = create<FormDraftResumeStore>((set, get) => ({
  pending: null,
  setPending: (draft) => set({pending: draft}),
  consumePending: () => {
    const draft = get().pending;
    if (!draft) {
      return null;
    }
    set({pending: null});
    return draft;
  },
  clearPending: () => set({pending: null}),
}));
